
import { Recommendation, RecommendationPriority } from '@/types/assessment';

// Determine priority based on gap size
export const getRecommendationPriority = (gap: number): RecommendationPriority => {
  if (gap >= 2) return 'high';
  if (gap >= 1.0) return 'medium';
  return 'low';
};

// Sort recommendations by priority and gap size
export const sortRecommendationsByPriority = (recommendations: Recommendation[]): Recommendation[] => {
  return recommendations.sort((a, b) => {
    const priorityOrder = { high: 3, medium: 2, low: 1 };
    if (priorityOrder[a.priority] !== priorityOrder[b.priority]) {
      return priorityOrder[b.priority] - priorityOrder[a.priority];
    }
    return b.gap - a.gap;
  });
};
